module.exports = __webpack_public_path__ + "static/media/cq_notifiche.78e9acca.svg";